import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trail } from 'react-spring';
import { useStaticQuery, graphql } from 'gatsby';

import Slider from 'react-slick';

import { ComponentHeading } from './elements';
import CategoryItem from './CategoryItem';

const Container = styled.div`
  background-image: url('/images/category-bg.jpg');
  background-attachment: fixed !important;
  .is-multiline {
    margin-top: 1rem;
    justify-content: space-between;
  }
  .container {
    padding: 2rem 1.5rem;
  }
  .image {
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .slick-dots li button:before {
    font-size: 1rem;
  }
  .slick-dots li.slick-active button:before,
  .slick-dots li.slick-active button:hover {
    opacity: 1;
    color: ${(props) => props.theme.mainBrandColor};
  }
  .slick-dots {
    bottom: -35px;
  }
`;

const CategoryList = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <Container className="section">
      <div className="container">
        <figure className="image is-128x128 has-text-centered">
          <img
            className="is-rounded has-text-centered"
            src="/images/birthday.svg"
            alt="catagory"
          />
        </figure>
        <ComponentHeading
          title="FEATURED CATEGORIES"
          subtitle="Kravings has a wide range of categories offering an extensive selection of baking supplies. We love inspiring and encouraging our bakers and chefs to create incredible baking recipes."
        />
        <Slider {...settings}>
          {data && data.map((item) => <CategoryItem item={item} />)}
        </Slider>
      </div>
    </Container>
  );
};
export default CategoryList;
